<template>
    <div class="terminal-wrapper">
        <div class="terminal-topbar">
            <svg width="500px" height="100px" viewBox="0 0 500 100" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <defs></defs>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Group">
                        <circle id="Oval" fill="#F62834" cx="50" cy="50" r="50"></circle>
                        <circle id="Oval" fill="#8BAF1B" cx="250" cy="50" r="50"></circle>
                        <circle id="Oval" fill="#FBAC3E" cx="450" cy="50" r="50"></circle>
                    </g>
                </g>
            </svg>
        </div>
        <div class="terminal-inner bg-deveo-light">
<pre v-if="showTerminal"><vue-typer :text='["$ vue init deveodk/vue-core"]' :repeat='0' :shuffle='true' initial-action='typing'
                  :pre-type-delay='0' :type-delay='140' :pre-erase-delay='30000' :erase-delay='0' erase-style='clear'
                  :erase-on-complete='false' caret-animation='smooth'></vue-typer>

<vue-typer :text='["Project name: "]' :repeat='0' :shuffle='true' initial-action='typing'
           :pre-type-delay='4000' :type-delay='0' :pre-erase-delay='30000' :erase-delay='0' erase-style='clear'
           :erase-on-complete='false' caret-animation='smooth'></vue-typer><vue-typer :text='["awesome-project"]'
           :repeat='0' :shuffle='true' initial-action='typing' :pre-type-delay='4500' :type-delay='140'
           :pre-erase-delay='30000' :erase-delay='0' erase-style='clear' :erase-on-complete='false'
           caret-animation='smooth'></vue-typer>

    <vue-typer :text='["Generated: awesome-project"]' :repeat='0' :shuffle='true' initial-action='typing'
               :pre-type-delay='7000' :type-delay='0' :pre-erase-delay='30000' :erase-delay='0' erase-style='clear'
               :erase-on-complete='false' caret-animation='smooth'></vue-typer>

<vue-typer :text='["$ cd awesome-project"]' :repeat='0' :shuffle='true' initial-action='typing'
           :pre-type-delay='8000' :type-delay='140' :pre-erase-delay='30000' :erase-delay='0' erase-style='clear'
           :erase-on-complete='false' caret-animation='smooth'></vue-typer>
<vue-typer :text='["$ npm install"]' :repeat='0' :shuffle='true' initial-action='typing'
           :pre-type-delay='11500' :type-delay='140' :pre-erase-delay='30000' :erase-delay='0' erase-style='clear'
           :erase-on-complete='false' caret-animation='smooth'></vue-typer>
<vue-typer :text='["$ npm run dev"]' :repeat='0' :shuffle='true' initial-action='typing'
           :pre-type-delay='13500' :type-delay='140' :pre-erase-delay='30000' :erase-delay='0' erase-style='clear'
           :erase-on-complete='false' caret-animation='smooth'></vue-typer>
</pre>
<pre v-else>









</pre>
        </div>
        <!--<p>
            Hent den nyeste version af Deveo Core <a href="#">her</a>
        </p>-->
    </div>
</template>
<script>
    import { VueTyper } from 'vue-typer'
    export default {
        data () {
            return {
                showTerminal: true
            }
        },
        components: {
            'vue-typer': VueTyper
        },
        created () {
            window.onlineInterval = setInterval(() => {
                this.restartTerminal()
            }, 17000)
        },
        beforeDestroy: (
            window.clearInterval(window.onlineInterval)
        ),
        methods: {
            restartTerminal () {
                this.showTerminal = false
                setTimeout(() => {
                    this.showTerminal = true
                }, 1)
            }
        }
    }
</script>
<style type="scss">
    .terminal-col p{
        font-size: 12px;
    }
    .terminal-wrapper{

    }
    .terminal-topbar{
        height: 30px;
        background: rgba(230,230,230,.7);
        text-align: left;
        border-radius: 4px 4px 0px 0px;
    }
    .terminal-topbar svg{
        height: 12px;
        margin-top: 9px;
        margin-left: 8px;
        width: initial;
    }
    pre{
        border-radius: 0px 0px 4px 4px;
    }
    .terminal-wrapper .vue-typer .custom.char.typed{
        font-weight: 100;
        color: #fff;
    }
    .vue-typer .custom.caret{
        display: none !important;
    }
</style>



// WEBPACK FOOTER //
// terminal.vue?18c4cd9c